import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import store from './store'
import VueNumber from 'vue-number-animation'

// import style
import 'swiper/css/swiper.css'

import './registerServiceWorker'
import router from './router'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.config.productionTip = false
Vue.use(VueNumber)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
